const faqData = [
  {
    key: 'q1',
    question: "What sizes are available for men's clothing?",
    answer:
      "We offer a wide range of sizes from small to XXXL for our men's clothing.",
  },
  {
    key: 'q2',
    question: "Do you have a return policy for men's clothing?",
    answer:
      "Yes, we have a 30-day return policy for all men's clothing items. Please check our Returns & Exchanges page for more details.",
  },
  {
    key: 'q3',
    question: "Are your women's clothing items true to size?",
    answer:
      "Our women's clothing items generally follow standard sizing guidelines. We recommend checking our size chart for accurate measurements.",
  },
  {
    key: 'q4',
    question: "What materials are your women's clothes made of?",
    answer:
      "We use a variety of high-quality materials including cotton, silk, polyester, and more for our women's clothing line.",
  },
  {
    key: 'q5',
    question: 'Is your jewelry made of genuine materials?',
    answer:
      'Yes, all our jewelry pieces are crafted from genuine materials such as sterling silver, gold, and precious gemstones.',
  },
  {
    key: 'q6',
    question: 'Do you offer customization for jewelry?',
    answer:
      'Currently, we do not offer customization services for jewelry. However, we have a diverse collection to choose from.',
  },
  {
    key: 'q7',
    question: 'What types of electronics do you sell?',
    answer:
      'We offer a range of electronics including smartphones, laptops, headphones, smartwatches, and more from top brands.',
  },
  {
    key: 'q8',
    question: 'Are your electronics covered by a warranty?',
    answer:
      "Yes, all our electronics come with a manufacturer's warranty. The duration of the warranty may vary depending on the product.",
  },
  // You can add more questions and answers here
];

export default faqData;
